import { isAdminUser } from "../../services/authService";

export const PRICE_TRACE_DEBUG_STORAGE_KEY = "PRICE_TRACE_DEBUG";

/**
 * Admin-only price trace UI, with optional localStorage override for debugging.
 */
export function isPriceTraceDebugEnabled() {
  try {
    return (
      typeof window !== "undefined" &&
      window.localStorage?.getItem(PRICE_TRACE_DEBUG_STORAGE_KEY) === "1"
    );
  } catch {
    return false;
  }
}

export function canShowAdminPriceTrace() {
  return isAdminUser() || isPriceTraceDebugEnabled();
}
